import "./App.css";
import backgroundDots from "./assets/images/webp/background-dots.webp";
import BuyDunce from "./components/BuyDunce";
import ContactAddress from "./components/ContactAddress";
import Disclosure from "./components/Disclosure";
import Faqs from "./components/Faqs";
import Hero from "./components/Hero";
import HowToBuy from "./components/HowToBuy";
import JoinDanceCommunity from "./components/JoinDunceCommunity";
import Roadmap from "./components/Roadmap";
import TrackChart from "./components/TrackChart";
import WhatDunce from "./components/WhatDunce";
import BackToTop from "./components/common/BackToTop";
import Disclaimer from "./components/common/Disclaimer";
import Footer from "./components/common/Footer";
import FooterSlider from "./components/common/FooterSlider";
import LogoSlider from "./components/common/LogoSlider";

function App() {
  return (
    <>
      <div className="overflow-x-clip relative">
        <Disclaimer />
        <BackToTop />
        <Hero />
        <LogoSlider />
        <WhatDunce />
        <BuyDunce />
        <HowToBuy />
        <ContactAddress />
        <TrackChart />
        {/* <Faqs/> */}
        <Roadmap />
        <JoinDanceCommunity />
        <FooterSlider />
        <Disclosure />
        <Footer />
        <img
          src={backgroundDots}
          alt="background-dots-image"
          className="w-full h-full absolute left-0 top-0 z-50 pointer-events-none"
        />
      </div>
    </>
  );
}

export default App;
